<div class="login-page">
    <div class="login-shell">
        <section class="login-intro">
            <div class="intro-visual" aria-hidden="true">
                <span class="orb orb-1"></span>
                <span class="orb orb-2"></span>
                <span class="orb orb-3"></span>
                <div class="intro-badge">
                    <span class="wave"></span>
                    <span class="wave"></span>
                    <span class="wave"></span>
                    <i class="fa fa-check"></i>
                </div>
            </div>
            <div class="intro-copy">
                <h2>Registration successful</h2>
                <p>Your sign-up request has been received. Complete the process using the link in your invitation email.</p>
                <ul class="intro-points">
                    <li><i class="fa fa-envelope"></i><span>Check your email inbox</span></li>
                    <li><i class="fa fa-link"></i><span>Click the invitation link</span></li>
                    <li><i class="fa fa-user"></i><span>Complete your profile</span></li>
                </ul>
            </div>
        </section>

        <section class="login-panel">
            <div class="login-brand">
                <img src="assets/images/sovos-logo-dark.png" alt="Sovos">
            </div>
            <h1 class="login-title">Thank you</h1>
            <p class="login-message">
                Thank you for signing up for Sovos. Please complete the registration process by clicking on the link
                in the invitation mail sent to your email ID.
            </p>
            <button type="button" class="login-btn login-btn-primary login-btn-submit" (click)="signIn()">SIGN IN</button>
            <p class="login-note">You will be redirected to sign in automatically in a few seconds.</p>
        </section>
    </div>
</div>
